const SCROLL_ANIMATION_TRIGGER_CLASSNAME = "m-scroll-trigger";
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = "m-scroll-trigger--offscreen";
const SCROLL_ANIMATION_CANCEL_CLASSNAME = "m-scroll-trigger--cancel";
const SCROLL_ANIMATION_DESIGN_MODE_CLASSNAME = "m-scroll-trigger--design-mode";

function isElementInAnimationViewport(element) {
  const rect = element.getBoundingClientRect();
  const viewportBottom = window.innerHeight - 50;
  return rect.top < viewportBottom && rect.bottom > 0;
}

function handleMobileChange(element) {
  const removeTriggerClass = () => element.classList.remove(SCROLL_ANIMATION_TRIGGER_CLASSNAME);

  if (MinimogTheme.config.mqlMobile || element.dataset.type === "fixed") {
    removeTriggerClass();
  }

  document.addEventListener("matchMobile", removeTriggerClass);
  document.addEventListener("unmatchMobile", removeTriggerClass);
}

function onIntersection(entries, observer) {
  entries.forEach((entry, index) => {
    const { isIntersecting, target } = entry;

    if (isIntersecting) {
      if (target.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        target.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (target.hasAttribute("data-cascade")) {
          target.style.setProperty("--animation-order", String(index));
        }
      }
      observer.unobserve(target);
    } else {
      target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }

    if (target.classList.contains("m-sidebar")) {
      handleMobileChange(target);
    }
  });
}

const observer = new IntersectionObserver(onIntersection, {
  rootMargin: "0px 0px -50px 0px",
});

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const elements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));

  if (elements.length === 0) return;

  if (isDesignModeEvent) {
    elements.forEach((element) => {
      element.classList.add(SCROLL_ANIMATION_DESIGN_MODE_CLASSNAME);
      element.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
    });
    return;
  }

  elements.forEach((element) => {
    // Start hidden so CSS doesn't play the reveal before the observer runs
    if (!element.classList.contains(SCROLL_ANIMATION_DESIGN_MODE_CLASSNAME)) {
      element.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
    }
    observer.observe(element);
  });
}

/**
 * After images/fonts settle, layout often shifts on mobile. Elements that
 * briefly intersected (and were unobserved) can end up below the fold with
 * their animation already spent. Reset those and watch them again.
 */
function repairScrollAnimationTriggersAfterLoad() {
  const elements = Array.from(document.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));

  elements.forEach((element) => {
    if (element.classList.contains(SCROLL_ANIMATION_DESIGN_MODE_CLASSNAME)) return;

    if (!isElementInAnimationViewport(element)) {
      element.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
      observer.observe(element);
    }
  });
}

function bootScrollAnimationTriggers() {
  initializeScrollAnimationTrigger();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", bootScrollAnimationTriggers);
} else {
  bootScrollAnimationTriggers();
}

window.addEventListener("load", () => {
  // Double rAF: wait for post-load layout/paint (common mobile image shift)
  requestAnimationFrame(() => {
    requestAnimationFrame(repairScrollAnimationTriggersAfterLoad);
  });
});

if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", (event) => {
    initializeScrollAnimationTrigger(event.target, true);
  });
  document.addEventListener("shopify:section:reorder", () => {
    initializeScrollAnimationTrigger(document, true);
  });
}
